import Auth from '../api/auth';

/**
 * Returns the headers required by the FastAPI extension service.
 * Uses the logged-in user's Chatwoot session credentials from the
 * cw_d_session_info cookie so the backend can verify the caller.
 *
 * @returns {Object} headers object ready to pass to axios or fetch
 */
export function getCentralHeaders() {
  const authData = Auth.getAuthData();

  if (!authData) {
    // Not logged in — return empty object; the backend will reject with 401
    return {};
  }

  return {
    'access-token': authData['access-token'],
    'token-type': authData['token-type'] || 'Bearer',
    client: authData['client'],
    expiry: authData['expiry'],
    uid: authData['uid'],
  };
}
